<div class="flex flex-col gap-1 w-full">
  <label *ngIf="label" [for]="id" [id]="id + '-label'" class="block text-gray-1200 lg:text-[1.125rem] md:text-[1.125rem] sm:text-[1.125rem] xs:text-[1.125rem] text-[1rem] font-normal font-archivo leading-[29px]">{{label}} <span
      *ngIf="required" class="text-danger-500">*</span></label>
  <div class="relative w-full">
    <!-- Loading Skeleton -->
    @if (isLoading) {
    <div @skeletonFadeIn class="absolute inset-0 flex items-center px-3 pointer-events-none z-20 bg-transparent rounded-lg border border-gray-600 shadow-sm lg:h-[3.625rem] md:h-[3.625rem] sm:h-[3.625rem] xs:h-[3.625rem] h-[3rem]"
      [ngClass]="{
        'border-danger-500': hasError,
        'border-gray-600': !hasError
      }">
      <div class="w-full h-6 bg-gray-200 rounded skeleton-shimmer relative"></div>
    </div>
    }

    <div #containerRef [id]="id" [tabindex]="disabled || isLoading ? '-1' : '0'"
      [style.opacity]="isLoading ? '0' : '1'"
      [style.transition]="'opacity 200ms ease-out'"
      [style.background-color]="isLoading ? 'transparent' : null"
      class="flex flex-row  rounded-lg border shadow-sm w-full lg:h-[3.625rem]  md:h-[3.625rem]   sm:h-[3.625rem]  xs:h-[3.625rem]  h-[3rem] focus:outline-none focus:border-gray-500 focus-within:border-gray-500 cursor-pointer relative z-0"
      [ngClass]="[
    hasError ? 'border-danger-500' : 'border-gray-600',
    disabled ? 'bg-gray-200 pointer-events-none cursor-not-allowed' : '',
    isNestedToLeading ? 'rounded-r-none rounded-l-lg border-r-0' : '',
    isNestedToTrailing ? 'rounded-l-none rounded-r-lg' : '',
    !isNestedToLeading && !isNestedToTrailing ? 'rounded-lg' : '',
   ]" (click)="!disabled && !isLoading && toggleOptions(); $event.stopPropagation()" (keydown)="handleKeyDown($event)">
      <div class="flex flex-row flex-wrap items-center gap-1 pr-1 pl-[8px] py-1.5 w-full lg:h-[3.625rem]  md:h-[3.625rem]   sm:h-[3.625rem]  xs:h-[3.625rem]  h-[3rem] pointer-events-none">
        <!-- Multi-select chips -->
        <ng-container *ngIf="multiple; else singleValue">
          <ng-container *ngIf="selectedOptions.length > 0">
            <ng-container *ngFor="let selectedOption of selectedOptions | slice:0:3; trackBy: trackBySelectedOption">
              <NiFormChip
                [label]="selectedOption[stateField] || selectedOption[label] || selectedOption.name || selectedOption.value"
                size="medium"  radius="full" variant="plain" [removable]="!disabled" [showActionIcon]="!disabled"
                removeIconColor="text-[#B80012]"
                (onAction)="onRemoveItem(selectedOption[stateField] || selectedOption[valueField])"></NiFormChip>
            </ng-container>
            <ng-container *ngIf="selectedOptions.length > 3">
              <NiFormChip [label]="'+' + (selectedOptions.length - 3) + ' more'" size="small" variant="gray" radius="full"
                [removable]="false" [showActionIcon]="false" [disabled]="true"></NiFormChip>
            </ng-container>
          </ng-container>
          <input *ngIf="selectedOptions.length === 0" tabindex="-1" type="text" [tooltip]="value.toString()"
          [attr.autocomplete]="getAutocompleteValue()" [attr.data-form-type]="'other'" [attr.data-lpignore]="'true'" [attr.data-1p-ignore]="'true'" [name]="getAutocompleteSafeName()"
            class="block truncate pr-1  py-1 lg:text-[1.25rem] md:text-[1.25rem] sm:text-[1.25rem] xs:text-[1.25rem] text-[1rem] !font-archivo w-full outline-none border-0 focus:outline-none focus:ring-0 focus:border-0 placeholder:lg:text-[1.25rem] placeholder:md:text-[1.25rem] placeholder:text-[1.25rem] placeholder:xs:text-[1.25rem] placeholder:text-[1rem]   placeholder:text-gray-500 placeholder:font-archivo"
            [ngClass]="{'bg-transparent': !disabled, 'bg-gray-200 font-bold': disabled}"
            [placeholder]="placeholder" [value]="value" [disabled]="disabled" readonly>
        </ng-container>

        <ng-template #singleValue>
          <div
            *ngIf="displayDistanceParts as parts; else plainSingleValue"
            class="block truncate lg:text-[1.25rem] md:text-[1.25rem] sm:text-[1.25rem] xs:text-[1.25rem] text-[1rem] !font-archivo px-1 py-1 w-full pointer-events-none"
            [ngClass]="{'bg-transparent': !disabled, 'bg-gray-200 font-bold': disabled}"
            [attr.title]="value.toString()">
            <span class="text-inherit">{{ parts.name }}</span><span [style.color]="distanceMilesColor">{{ parts.miles }}</span>
          </div>
          <ng-template #plainSingleValue>
            <input tabindex="-1" type="text" [tooltip]="value.toString()" [attr.autocomplete]="getAutocompleteValue()" [attr.data-form-type]="'other'" [attr.data-lpignore]="'true'" [attr.data-1p-ignore]="'true'" [name]="getAutocompleteSafeName()"
              class="block truncate  lg:text-[1.25rem] md:text-[1.25rem] sm:text-[1.25rem] xs:text-[1.25rem] text-[1rem] !font-archivo  px-1 py-1 w-full pointer-events-none outline-none border-0 focus:outline-none focus:ring-0 focus:border-0 placeholder:text-gray-500 placeholder:lg:text-[1.25rem] placeholder:md:text-[1.25rem] placeholder:text-[1.25rem] placeholder:xs:text-[1.25rem] placeholder:text-[1rem]   placeholder:font-archivo"
              [ngClass]="{'bg-transparent': !disabled, 'bg-gray-200 font-bold': disabled}"
              [placeholder]="placeholder" [value]="value" [disabled]="disabled" readonly>
          </ng-template>
        </ng-template>
      </div>

      <button
        *ngIf="!disabled && hasClearableSingleSelection()"
        type="button"
        tabindex="-1"
        class="flex items-center justify-center pr-0.5 shrink-0 pointer-events-auto"
        aria-label="Clear selection"
        (click)="onClearButtonClick($event)"
        (mousedown)="$event.stopPropagation()"
        (focus)="preventFocus($event)">
        <NiFormIcon icon="Close" [class]="'!w-[1.25rem] !h-[1.25rem] text-gray-700 hover:text-gray-900'"></NiFormIcon>
      </button>

      <button *ngIf="!disabled" type="button" tabindex="-1" class="pr-1" 
        (click)="toggleOptions(); $event.stopPropagation(); $event.preventDefault()"
        (focus)="preventFocus($event)"
        (mousedown)="$event.preventDefault()"
        (keydown.tab)="$event.preventDefault()">
        <NiFormIcon icon="ArrowDropDown"
          [class]="'!w-[1.5rem] !h-[1.5rem] transition-transform duration-200 ' + (showOptions ? 'rotate-180' : '')">
        </NiFormIcon>
      </button>
    </div>

    <div class="flex items-end justify-between min-h-[25px]">
      <span *ngIf="hasError" class="flex items-end justify-between text-danger-500 text-[14px] font-archivo">{{errorMessage}}</span>
    </div>

    <div *ngIf="showOptions" #optionsRef @dropDownMenu @contentExpansion
      [tabindex]="disabled || isLoading ? '-1' : '0'"
      class="absolute z-[120] w-full overflow-auto rounded bg-white text-base shadow-[0px_3px_1px_-2px_rgba(0,0,0,0.2),0px_2px_2px_0px_rgba(0,0,0,0.14),0px_1px_5px_0px_rgba(0,0,0,0.12)] ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
      [style.max-height.px]="optionsMaxHeight"
      [style.top]="optionsPosition === 'above' ? 'auto' : '100%'"
      [style.bottom]="optionsPosition === 'above' ? '100%' : 'auto'"
      [style.margin-top]="optionsPosition === 'below' ? '4px' : '0'"
      [style.margin-bottom]="optionsPosition === 'above' ? '4px' : '0'"
      (click)="$event.stopPropagation()"
      (keydown)="handleListboxKeyDown($event)">

      <!-- Action Section (Top) -->
      <div *ngIf="showActionSection && actionSectionPosition === 'top' && actionButtons.length > 0"
        class="ni-action-section ni-action-section-top">
        <ng-container *ngTemplateOutlet="actionButtonsTemplate"></ng-container>
      </div>

      <!-- Favorites Section -->
      <ng-container *ngIf="showFavoriteToggle">
        <div *ngIf="favoriteOptions.length > 0" class="ni-favorites-section">
          <div class="ni-favorites-header">
            <span class="ni-favorites-label">FAVORITES</span>
          </div>
        </div>

        <div *ngFor="let option of favoriteOptions; index as i; trackBy: trackByOption" #optionRefs 
          [id]="getOptionId(i)"
          class="menu-item" 
          [ngClass]="{'highlighted': highlightedIndex === i}"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()">
          <NiFormOption [option]="option" [multiple]="multiple"
            [selected]="!!(selected === option[stateField] || getSelected().includes(option[stateField]))"
            [highlighted]="false" [optionLabel]="stateField" [checkIcon]="'tick'"
            [showFavoriteToggle]="showFavoriteToggle" [showBadge]="showBadge"
            [highlightDistanceMiles]="highlightDistanceMiles"
            (optionClick)="selectOption($event)"
            (favoriteToggle)="onFavoriteToggle($event)">
          </NiFormOption>
        </div>
      </ng-container>

      <!-- Separator between favorites and regular options -->
      <hr *ngIf="showFavoriteToggle && favoriteOptions.length > 0 && nonFavoriteOptions.length > 0"
        class="ni-separator">

      <!-- Non-Favorite Section -->
      <ng-container *ngIf="showFavoriteToggle">
        <div *ngFor="let option of nonFavoriteOptions; index as i; trackBy: trackByOption" #optionRefs 
          [id]="getOptionId(favoriteOptions.length + i)"
          class="menu-item" 
          [ngClass]="{'highlighted': highlightedIndex === (favoriteOptions.length + i)}"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()">
          <NiFormOption [option]="option" [multiple]="multiple"
            [selected]="!!(selected === option[stateField] || getSelected().includes(option[stateField]))"
            [highlighted]="false" [optionLabel]="stateField" [checkIcon]="'tick'"
            [showFavoriteToggle]="showFavoriteToggle" [showBadge]="showBadge"
            [highlightDistanceMiles]="highlightDistanceMiles"
            (optionClick)="selectOption($event)"
            (favoriteToggle)="onFavoriteToggle($event)">
          </NiFormOption>
        </div>
      </ng-container>

      <!-- Fallback for when favorites are disabled -->
      <ng-container *ngIf="!showFavoriteToggle">
        <div *ngFor="let option of filteredOptions; index as i; trackBy: trackByOption" #optionRefs 
          [id]="getOptionId(i)"
          class="menu-item" 
          [ngClass]="{'highlighted': highlightedIndex === i}"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()">
          <NiFormOption [option]="option" [multiple]="multiple"
            [selected]="selected === option[stateField] || getSelected().includes(option[stateField])"
            [highlighted]="false" [optionLabel]="stateField" [checkIcon]="'tick'"
            [showFavoriteToggle]="showFavoriteToggle" [showBadge]="showBadge"
            [highlightDistanceMiles]="highlightDistanceMiles"
            (optionClick)="selectOption($event)"
            (favoriteToggle)="onFavoriteToggle($event)">
          </NiFormOption>
        </div>
      </ng-container>

      <output *ngIf="!filteredOptions.length"
        class="relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 menu-item block" >
        <span class="block truncate">No data found</span>
      </output>

      <!-- Action Section (Bottom) -->
      <div *ngIf="showActionSection && actionSectionPosition === 'bottom' && actionButtons.length > 0"
        class="ni-action-section ni-action-section-bottom">
        <ng-container *ngTemplateOutlet="actionButtonsTemplate"></ng-container>
      </div>
    </div>
  </div>

  <!-- Action Buttons Template -->
  <ng-template #actionButtonsTemplate>
    <div class="ni-action-buttons" [ngClass]="{
      'ni-action-buttons-left': actionSectionAlignment === 'left',
      'ni-action-buttons-center': actionSectionAlignment === 'center',
      'ni-action-buttons-right': actionSectionAlignment === 'right'
    }">
      <button *ngFor="let button of actionButtons; trackBy: trackByActionButton" type="button" class="ni-action-button"
        [class.ni-action-button-primary]="button.variant === 'primary'"
        [class.ni-action-button-secondary]="button.variant === 'secondary'"
        [class.ni-action-button-danger]="button.variant === 'danger'"
        [class.ni-action-button-success]="button.variant === 'success'"
        [class.ni-action-button-disabled]="button.disabled" [disabled]="button.disabled"
        (click)="onActionButtonClick(button.action, $event)">
        <NiFormIcon *ngIf="button.icon" [icon]="button.icon" class="ni-action-button-icon"></NiFormIcon>
        <span class="ni-action-button-label">{{ button.label }}</span>
      </button>
    </div>
  </ng-template>
</div>